import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { TabIndex } from '../types';
import { useStyles } from '../styles';

interface EmptyStateProps {
  activeTab: TabIndex;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ activeTab }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const content =
    activeTab === TabIndex.THIRD_PARTY_RESULTS
      ? {
          title: t('myDrugTesting.emptyState.thirdPartyResults.title'),
          subtitle: t('myDrugTesting.emptyState.thirdPartyResults.subtitle'),
        }
      : {
          title: t('myDrugTesting.emptyState.appointments.title'),
          subtitle: t('myDrugTesting.emptyState.appointments.subtitle'),
        };

  return (
    <Box className={classes.emptyState} data-testid="my-drug-testing-empty-state">
      <Typography variant="h6" className={classes.emptyStateTitle} data-testid="my-drug-testing-empty-state-title">
        {content.title}
      </Typography>
      <Typography variant="body2" className={classes.emptyStateSubtitle}>
        {content.subtitle}
      </Typography>
    </Box>
  );
};
